import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';

import App from './App.vue';
import i18n from './i18n';
import router from './router';
import { queryClient } from './queries/_shared/queryClient';
import { useThemeStore } from './stores/theme';
import { initCordovaRuntime } from './services/cordova/initCordova';
import { initLowVisionMode } from './services/accessibility/lowVisionMode';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-icons/iconfont/material-icons.css';
import './styles.css';
import './styles.low-vision.css';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(VueQueryPlugin, { queryClient });

const themeStore = useThemeStore(pinia);
themeStore.initTheme();
initLowVisionMode();
initCordovaRuntime({ router, pinia });

app.mount('#app');
